<template>
  <div>
    <v-img
      eager
      class="logo-supply"
      width="100%"
      max-width="200px"
      :src="logo"
    ></v-img>
    <v-sheet
      max-width="200px"
      style="margin-top: -15px !important; position: sticky;"
      class="text-center mb-1 card-title"
      color="primary"
      elevation="1"
      dark
    >{{name}}</v-sheet>
  </div>
</template>
<script>
export default {
  name: 'CompanyLogo',
  props: {
    logo: String,
    name: String
  }
}
</script>
<style scoped>
.logo-supply {
  background-color: #ffffff;
  border-radius: 200px;
  box-shadow: #b73979 0px 0px 15px 0px;
}
</style>
